// eslint-disable-next-line no-shadow
export enum GfpManagementEnum {
  open = 'A',
  received = 'R',
  close = 'F',
  canceled = 'C',
  devolution = 'D',
  donation = 'M',
  occurrence = 'O'
}
